import { apiHttp, uploadHttp } from '/@/utils/http/axios';
import { SpecialMapType } from '/@/api/home/type';

const prefix = '/index';
const base = '';
const Api = {
  // CART_GOODS_NUM: prefix + '/cartGoodsNum',
  // CAROUSEL_LIST: prefix + '/carouselList',
  // SPECIAL_LIST: prefix + '/specialList',
  // NEW_GOODS: prefix + '/newGoods',
  // HOT_GOODS: prefix + '/hotGoods',
  // GET_ALL_COUNTY: prefix + '/getAllCounty',
  OAUTHTO: base + '/oauth/callback',
  HEADLOOP: base + prefix + '/headloop',
  SPECIAL: base + prefix + '/special',
  ANNOUNCE: base + prefix + '/announce',
  MODULE: base + prefix + '/module',
  SERVE: base + prefix + '/module/list',
  GETTOKEN: base + '/oauth/getToken',
  UPLOADIDCARD: base + '/emp/idcard',
};
/**
 * 获取token
 */
export function uploadIdCard(params: any) {
  return uploadHttp.post({
    url: Api.UPLOADIDCARD,
    params: params,
  });
}
/**
 * 获取token
 */
export function getToken() {
  return apiHttp.get({
    url: Api.GETTOKEN,
  });
}
/**
 * 获取wx授权
 */
export function authTo(params) {
  return apiHttp.get({
    url: Api.OAUTHTO,
    params,
  });
}
/**
 *首页轮播图
 * @param params
 * @returns
 */
export function getHeadLoop(params) {
  return apiHttp.get({
    url: Api.HEADLOOP,
    params,
  });
}
/**
 * 首页推荐
 * @param params
 * @returns
 */
export function getSpecial(params) {
  return apiHttp.get({
    url: Api.SPECIAL,
    params,
  });
}
/**
 * 站内信
 * @param params
 * @returns
 */
export function getAnnounce() {
  return apiHttp.get({
    url: Api.ANNOUNCE,
  });
}
/**
 * 获取首页菜单
 * @param params
 * @returns
 */
export function getModule() {
  return apiHttp.get({
    url: Api.MODULE,
  });
}
/**
 * 获取服务列表
 * @param params
 * @returns
 */
export function getServeList() {
  return apiHttp.get({
    url: Api.SERVE,
  });
}
/**
 * 获取购物车商品数量
 */
// export function cartGoodsNum() {
//     return apiHttp.get({
//         url: Api.CART_GOODS_NUM,
//     });
// }

/**
 * 获取已登录轮播列表
 */
// export function carouselList() {
//     return apiHttp.get({
//         url: Api.CAROUSEL_LIST,
//     });
// }

// /**
//  * 获取生日专区和传统文娱专区列表
//  */
// export function specialList() {
//     return apiHttp.get<SpecialMapType>({
//         url: Api.SPECIAL_LIST,
//     });
// }

// /**
//  * 获取新品上架商品
//  */
// export function newGoods() {
//     return apiHttp.get({
//         url: Api.NEW_GOODS,
//     });
// }

// /**
//  * 获取热销商品
//  */
// export function hotGoods() {
//     return apiHttp.get({
//         url: Api.HOT_GOODS,
//     });
// }

// /**
//  * 获取全部省市县
//  */
// export function getAllCounty() {
//     return apiHttp.get({
//         url: Api.GET_ALL_COUNTY,
//     });
// }
